// Mock data for Here Together Singapore community landing page

export const siteData = {
  brand: {
    name: "Never Alone in Singapore",
    shortName: "Never Alone SG",
    tagline: "A quiet corner of Singapore.",
  },
  nav: [
    { label: "About", href: "#mission" },
    { label: "Experience", href: "#experience" },
    { label: "Why Join", href: "#why-join" },
    { label: "Join", href: "#join" },
  ],
  hero: {
    eyebrow: "For Singapore. For Real Life.",
    titleStart: "Never Alone in Singapore:",
    titleEnd: "A shared space for real life, exactly as it is.",
    subtitle:
      "Most online spaces in Singapore want to fix you, hustle you, or change your mind. Never Alone in Singapore is different. It is a quiet, private community for those who want to reflect, share, or simply be alongside others who understand, without the pressure to perform.",
    cardTitle: "No cost. No strings. Just being here, together.",
    cardSubtitle: "Enter your details below to join our Singapore community.",
    cta: "Join the Free Community",
    disclaimer: "We won't send spam. Unsubscribe at any time.",
    socialProof: "Join over 600+ members from across Singapore in our free community!",
    badgeText: "Community",
    badgeTitle: "Never Alone",
    heroBg:
      "https://images.unsplash.com/photo-1629619177853-4971bab8bfd4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxwZWFjZWZ1bCUyMG1pc3R5JTIwbGFrZXxlbnwwfHx8Ymx1ZXwxNzgxOTExOTYxfDA&ixlib=rb-4.1.0&q=85",
    birdsImg:
      "https://images.unsplash.com/photo-1591696709491-a33c1976dca2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxiaXJkcyUyMGJyYW5jaCUyMHdhdGVyfGVufDB8fHxibHVlfDE3ODE5MTE5NjF8MA&ixlib=rb-4.1.0&q=85",
  },
  mission: {
    eyebrow: "Our Mission",
    title: "We don't need to be fixed. We need to be heard.",
    body: "In a city full of \"hacks,\" \"solutions,\" KPIs, and unsolicited advice, finding a place to just exist in Singapore is rare. We created this space because sometimes, you don't need a strategy. You just need to get things off your chest in a place that feels safe.",
    offerTitle: "At Never Alone in Singapore, we offer:",
    offers: [
      {
        title: "Zero Pressure",
        text: 'No "content" to keep up with or "challenges" to complete.',
      },
      {
        title: "True Privacy",
        text: "A dedicated space away from the noise of social media algorithms.",
      },
      {
        title: "Quiet Presence",
        text: 'The comfort of knowing you aren\'t alone in the "messy middle" of life.',
      },
    ],
    image:
      "https://images.unsplash.com/photo-1591696709491-a33c1976dca2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxiaXJkcyUyMGJyYW5jaCUyMHdhdGVyfGVufDB8fHxibHVlfDE3ODE5MTE5NjF8MA&ixlib=rb-4.1.0&q=85",
  },
  experience: {
    eyebrow: "The Community Experience",
    title: "A Kind, Private Sanctuary",
    bodyOne:
      "Healing and reflection happen best when we feel safe. To find true perspective, you need a space that operates with a different set of values, one where you are accepted exactly as you are.",
    bodyTwo:
      "We move away from the noise and comparison of public social media. We use a dedicated, private platform that serves as your sanctuary, a place to exhale and speak honestly without the world watching.",
    features: [
      {
        title: "Kindred Spirits",
        text: "Connect with fellow Singaporeans who understand the weight of real life and the value of a quiet, supportive presence.",
      },
      {
        title: "Focused Presence",
        text: "A streamlined space for honest sharing, quiet listening, and simply being yourself.",
      },
    ],
    image:
      "https://images.unsplash.com/photo-1654252548553-8836da424856?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHw0fHxiaXJkcyUyMGJyYW5jaCUyMHdhdGVyfGVufDB8fHxibHVlfDE3ODE5MTE5NjF8MA&ixlib=rb-4.1.0&q=85",
  },
  whyJoin: {
    eyebrow: "Joining Never Alone SG",
    title: "Why Join?",
    body: "Everyone here is fighting a great battle, whether it is visible or not. From HDB heartlands to Orchard, from young professionals to retirees, we simply choose to fight it alongside one another.",
    subBody: "Joining is free, and the value is in the environment. You should join if:",
    reasons: [
      "You are tired of 'performing' on social media.",
      "You want a supportive space to vent or reflect without being 'corrected.'",
      "You value kindness and gentleness over debate and 'hot takes.'",
      "You'd appreciate a community that gets the unique pace of life in Singapore.",
    ],
    image:
      "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxhc2lhbiUyMG1hbiUyMHNtaWxpbmd8ZW58MHx8fHwxNzgxOTExOTYxfDA&ixlib=rb-4.1.0&q=85",
  },
  finalCta: {
    title: "Join a community where you can finally put the mask down.",
    bodyOne:
      "Life in Singapore is loud enough. You don't need another group that demands your attention, your 'growth,' or your transformation. You just need a place where it's okay to be human.",
    bodyTwo:
      "Whether you have something heavy on your mind or you just want to sit quietly in a space where others 'get it,' the door is open. No hidden agendas, no membership fees, and no pressure to perform.",
    closer: "Take a seat. We're glad you're here.",
    cta: "Join the Free Community",
  },
  footer: {
    legal: "© 2025 Never Alone in Singapore. A quiet space made in Singapore.",
    links: [
      { label: "Privacy", to: "/privacy" },
      { label: "Terms", to: "/terms" },
      { label: "Contact", to: "/contact" },
    ],
  },
};
